/**
 * Helpers para detectar el entorno de ejecución (browser vs SSR/Node) y la
 * disponibilidad de APIs del navegador. El SDK debe poder importarse en Node
 * sin romperse, por eso todo acceso a globals del browser pasa por aquí.
 */

/** ¿Existe el objeto global `window`? */
export function hasWindow(): boolean {
  return typeof window !== 'undefined';
}

/** ¿Existe el objeto global `document`? */
export function hasDocument(): boolean {
  return typeof document !== 'undefined';
}

/** ¿`localStorage` está disponible y es escribible? (puede fallar en modo incógnito) */
export function hasLocalStorage(): boolean {
  try {
    if (typeof localStorage === 'undefined') return false;
    const testKey = '__veo_test__';
    localStorage.setItem(testKey, '1');
    localStorage.removeItem(testKey);
    return true;
  } catch {
    return false;
  }
}

/** ¿`navigator.sendBeacon` está disponible? */
export function hasNavigatorSendBeacon(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
}
